import { useEffect } from 'react';
import { fetchNotifications } from './api';
import { hydrateNotifications } from './store';

/**
 * Загружает историю уведомлений с сервера при входе (до/параллельно с SSE).
 * Ключ — `owner` (пользователь+подписка): перезагружается при смене личности,
 * чтобы список соответствовал текущему получателю (§4). При `null` не грузим.
 */
export function useNotificationBootstrap(owner: string | null): void {
  useEffect(() => {
    if (owner === null) return;

    let cancelled = false;
    void fetchNotifications()
      .then((items) => {
        if (cancelled) return;
        if (items.length === 0) return;
        hydrateNotifications(
          items.map((n) => ({
            id: n.id,
            type: n.type,
            accountId: n.accountId,
            mailboxId: n.mailboxId,
            messageId: n.messageId,
            from: n.from,
            subject: n.subject,
            attachmentCount: n.attachmentCount,
            createdAt: n.createdAt,
          })),
        );
      })
      .catch(() => {
        /* деградация: SSE продолжит наполнять стор */
      });

    return () => {
      cancelled = true;
    };
  }, [owner]);
}
